/**
 * Returns a promise that resolves in ms
 * @param ms
 */
export const wait = async (ms: number) => new Promise(r => setTimeout(r, ms))
